import styled from "styled-components";

const SecondaryText = styled.div`
  font-size: 15px;
  font-weight: 650;
  /* max-width: 300px; */
  opacity: 0.7;
  color: var(--element);
  line-height: 20px;
  white-space: pre-line;
  /* font-family: "Montserrat", sans-serif; */
`;

export default SecondaryText;
